import React from 'react'
import {
  B2B_COPILOT_PLAN_AI_LOG_STEPS_AFTER_WRITE,
} from './b2bCopilotPlanDemoContent.part03.js'
import {
  B2B_COPILOT_PLAN_AI_LOG_STEPS_INITIAL,
} from './b2bCopilotPlanDemoContent.part02.js'

export const B2B_COPILOT_PLAN_AI_LOG_STEPS = [
  ...B2B_COPILOT_PLAN_AI_LOG_STEPS_INITIAL,
  ...B2B_COPILOT_PLAN_AI_LOG_STEPS_AFTER_WRITE,
]

export const B2B_COPILOT_PLAN_SUMMARY_INTRO = `Here's a summary of what the plan covers — check the preview panel for the full detail:`

export const B2B_COPILOT_PLAN_SUMMARY_BODY =
  '10 phases, ~9.5 hours total — designed to hit every evaluation criterion without overbuilding.'

/** @deprecated Use structured blocks via buildB2bCopilotPlanFinalBlocks */

export const B2B_COPILOT_PLAN_SUMMARY_MARKDOWN = `${B2B_COPILOT_PLAN_SUMMARY_INTRO}

### Plan at a Glance

${B2B_COPILOT_PLAN_SUMMARY_BODY}

#### The Phases`

export const B2B_COPILOT_PLAN_PHASE_TABLE_DATA = [
  { '#': '0', What: 'Scaffolding — Docker Compose, Vite, FastAPI skeleton', Time: '45 min' },
  { '#': '1', What: 'DB schema — SQLModel tables, Alembic migrations, pgvector + FTS setup', Time: '60 min' },
  { '#': '2', What: 'Synthetic data — seed_data.py with injected price spikes, disruptions, naming aliases', Time: '45 min' },
  { '#': '3', What: 'Document ingestion — pypdf/docx text extraction, chunking, batch embeddings → pgvector', Time: '60 min' },
  { '#': '4', What: 'Retrieval layer — vector search + PostgreSQL FTS + Reciprocal Rank Fusion for hybrid', Time: '45 min' },
  { '#': '5', What: 'Analytics layer — deterministic pandas for pricing spikes, exposure, fulfillment (no LLM math)', Time: '60 min' },
  {
    '#': '6',
    What: 'LangGraph workflow — 7 real nodes: intent classifier → entity extractor → conditional router → doc retriever → data analyzer → hybrid aggregator → answer synthesizer → review escalator',
    Time: '90 min',
  },
  { '#': '7', What: 'FastAPI endpoints — typed Pydantic schemas, /investigate, /ingest/*, /health, /examples', Time: '45 min' },
  {
    '#': '8',
    What: 'React + TypeScript UI — query panel, filter bar, citations drawer, workflow trace, review banner',
    Time: '60 min',
  },
  { '#': '9', What: 'Tests — unit (analytics, RRF), integration (API contracts, route selection, needs_review fallback)', Time: '45 min' },
  { '#': '10', What: 'Docs — README, architecture.md, benchmark_queries.md', Time: '30 min' },
]

export const B2B_COPILOT_PLAN_KEY_DESIGN_ITEMS = [
  'pgvector + PG full-text search for hybrid retrieval — no Elasticsearch needed, keeps infra lean',
  'SQLModel so Pydantic models and ORM tables share definitions',
  'LLM never does math — all analytics are deterministic pandas; LLM only synthesizes prose',
  'Conflict detection built into the graph — overlapping policy docs and alias mismatches trigger needs_review',
  'Benchmark set has 15 queries covering all 5 route types, including conflicting-evidence traps',
]

export const B2B_COPILOT_PLAN_KEY_DESIGN_CLOSING =
  'The plan also includes a scope triage guide — exactly what to cut first if you fall behind, and what to never cut regardless.'

/** @deprecated Use structured blocks via buildB2bCopilotPlanFinalBlocks */
